import { EditorState, Modifier, SelectionState } from "draft-js";

import PropTypes from "prop-types";

/**
 * @param   {EditorState} editorState
 * @param   {Function}    onChange
 * @returns {Function}
 */
function handleSetBlockData(editorState, onChange) {
  return (block, data) => {
    const content = editorState.getCurrentContent();

    const currentSelection = new SelectionState({
      anchorKey: block.key,
      anchorOffset: 0,
      focusKey: block.key,
      focusOffset: block.getLength(),
    });

    onChange(
      EditorState.push(editorState, Modifier.mergeBlockData(content, currentSelection, data), "change-block-data"),
    );
  };
}

/**
 * @param   {EditorState} editorState
 * @param   {Function}    onChange
 * @returns {Function}
 */
function handleRemoveBlock(editorState, onChange) {
  return block => {
    const currentSelection = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    const keyAfter = contentState.getKeyAfter(block.key);
    const blockMap = contentState.getBlockMap().delete(block.key);

    onChange(
      EditorState.forceSelection(
        EditorState.push(
          editorState,
          contentState.merge({
            blockMap,
            selectionAfter: currentSelection,
          }),
          "remove-range",
        ),
        new SelectionState({
          anchorKey: keyAfter,
          anchorOffset: 0,
          focusKey: keyAfter,
          focusOffset: block.getLength(),
        }),
      ),
    );
  };
}

export default function EditorBlockHandling({ editorState, onChange, children }) {
  return children({
    removeBlock: handleRemoveBlock(editorState, onChange),
    setBlockData: handleSetBlockData(editorState, onChange),
  });
}

EditorBlockHandling.propTypes = {
  editorState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
};
